module.exports = __webpack_public_path__ + "img/check-white.9b7fd176.svg";